import script from "./TicketSupportSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketSupportSingle.vue?vue&type=script&setup=true&lang=js"

import "./TicketSupportSingle.vue?vue&type=style&index=0&id=6926d5f7&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6926d5f7"]])

export default __exports__